import React from "react";
import styles from "./PendingOrders.module.css";
import { TextComponent } from "../../../../../components";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";

const PendingOrders = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/ViewOrder");
  };
  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },
    {
      title: "Order Created By",
      dataIndex: "OrderCreatedBy",
      key: "Order Created By",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },
    {
      title: "Order ID",
      dataIndex: "OrderID",
      key: "Order ID",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },

    {
      title: "Date Created",
      key: "Date Created",
      dataIndex: "DateCreated",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (status) => {
        let color = "default";
        switch (status) {
          case "cancelled":
            color = "#FF0000";
            break;
          case "in progress":
            color = "#F7630C";
            break;
          case "completed":
            color = "#008000";
            break;
          default:
            color = "#000000";
        }
        return (
          <TextComponent
            style={{ color: color }}
            text={status}
            padding={"0px"}
            fontFamily={"Inter-semiBold"}
          />
        );
      },
    },
    {
      title: "Due Date",
      key: "Due Date",
      dataIndex: "DueDate",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },
  ];
  const data = [
    {
      No: "01",
      OrderCreatedBy: "Joshua Jones",
      OrderID: "13545",
      DateCreated: "Jul 31, 2025",
      Status: "Pending",

      DueDate: "Aug 01, 2025",
      Button: (
        <button className={styles.TableButton} onClick={handleNavigate}>
          View Order
        </button>
      ),
    },
    {
      No: "02",
      OrderCreatedBy: "Joshua Jones",
      OrderID: "13545",
      DateCreated: "Jul 31, 2025",
      Status: "Pending",

      DueDate: "Aug 01, 2025",
      Button: (
        <button className={styles.TableButton} onClick={handleNavigate}>
          View Order
        </button>
      ),
    },
    {
      No: "03",
      OrderCreatedBy: "Joshua Jones",
      OrderID: "13545",
      DateCreated: "Jul 31, 2025",
      Status: "Pending",

      DueDate: "Aug 01, 2025",
      Button: (
        <button className={styles.TableButton} onClick={handleNavigate}>
          View Order
        </button>
      ),
    },
    {
      No: "04",
      OrderCreatedBy: "Joshua Jones",
      OrderID: "13545",
      DateCreated: "Jul 31, 2025",
      Status: "Pending",

      DueDate: "Aug 01, 2025",
      Button: (
        <button className={styles.TableButton} onClick={handleNavigate}>
          View Order
        </button>
      ),
    },
    {
      No: "05",
      OrderCreatedBy: "Joshua Jones",
      OrderID: "13545",
      DateCreated: "Jul 31, 2025",
      Status: "Pending",

      DueDate: "Aug 01, 2025",
      Button: (
        <button className={styles.TableButton} onClick={handleNavigate}>
          View Order
        </button>
      ),
    },
    {
      No: "06",
      OrderCreatedBy: "Joshua Jones",
      OrderID: "13545",
      DateCreated: "Jul 31, 2025",
      Status: "Pending",

      DueDate: "Aug 01, 2025",
      Button: (
        <button className={styles.TableButton} onClick={handleNavigate}>
          View Order
        </button>
      ),
    },
  ];
  return (
    <div className={styles.MainDiv}>
      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default PendingOrders;
